var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlarm = function SvgIconAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.816 2.629a1 1 0 1 0-1.414-1.414L1.215 4.402a1 1 0 1 0 1.414 1.414zM18.184 1.215a1 1 0 0 1 1.414 0l3.187 3.187a1 1 0 1 1-1.414 1.414L18.184 2.63a1 1 0 0 1 0-1.414M13 7.5a1 1 0 1 0-2 0V12a1 1 0 0 0 1 1h4.5a1 1 0 1 0 0-2H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlarm;